export function buildModuleSearchTarget(type, item, module) {
  if (!module) return null;
  if (type === "video") return { ...module, _openVideoId: item.id };
  if (type === "lesson") return { ...module, _openLeconId: item.id };
  if (type === "audio") return { ...module, _returnTab: "audios" };
  return module;
}
